import React from 'react';
import './notFound.scss';

const NotFound = () => {
	return (
		<div id="not-found">
			<div className="header">Oops!</div>
			<div className="error-code">404</div>
			<div className="error-message">
				Sorry, couldn't find what you're looking for
			</div>
		</div>
	);
};

export default NotFound;
